import { render, staticRenderFns } from "./CarUninvoiced.vue?vue&type=template&id=ecf061fe&"
import script from "./CarUninvoiced.vue?vue&type=script&lang=js&"
export * from "./CarUninvoiced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports